<core-generic-modal 
    [isOpen]="!!booking()" 
    [title]="'bookings.attachmentsModal' | translate"
    [mode]="modalmodes.CREATE" 
    [fields]="modalFields()"
    [modelFactory]="modelFactory" 
    [data]="model()" 
    (close)="onCloseEmit()"
    (save)="onSaveEmit($event)">
</core-generic-modal>